import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { CompanyProductPhaseBoard } from 'src/app/models/company_product_phase_board.model';
import { CompanyProductPhaseBoardCol } from 'src/app/models/company_product_phase_board_col.model';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';

import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-complete-company-product-phase-board-dialog',
  templateUrl: './complete-company-product-phase-board-dialog.component.html',
  styleUrls: ['./complete-company-product-phase-board-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatInput,
    MatDateRangeInput,
    MatStartDate,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatDialogActions,
    MatButton,
  ],
})
export class CompleteCompanyProductPhaseBoardDialogComponent implements OnInit {
  data = inject<{
    board: CompanyProductPhaseBoard;
    boards: CompanyProductPhaseBoard[] | null;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CompleteCompanyProductPhaseBoardDialogComponent>>(MatDialogRef);
  protected fb = inject(FormBuilder);
  private api = inject(ApiService);

  board: CompanyProductPhaseBoard = this.data.board;
  boards: CompanyProductPhaseBoard[] | null = this.data.boards;
  pendingIssues: number = 0;
  doneIssues: number = 0;
  form: FormGroup;
  loading: boolean = false;

  constructor() {
    this.form = this.fb.group({
      start_date: [dayjs().add(1, 'week').startOf('week').toDate(), Validators.required],
      end_date: [dayjs().add(2, 'week').endOf('week').toDate(), Validators.required],
      title: ['Sprint #X', Validators.required],
      status: ['new', Validators.required],
      existing_board: [''],
    });
  }

  ngOnInit(): void {
    this.countPendingAndDoneIssues();
  }

  countPendingAndDoneIssues() {
    this.board.company_product_phase_board_cols!.forEach((col: CompanyProductPhaseBoardCol) => {
      if (
        col.company_product_phase_board_col_role != null &&
        (col.company_product_phase_board_col_role.slug === 'done' || col.company_product_phase_board_col_role.slug === 'test')
      ) {
        this.doneIssues += col.product_task_boards.length;
      } else {
        this.pendingIssues += col.product_task_boards.length;
      }
    });
  }

  save() {
    if (this.loading) return;
    this.loading = true;
    const body = {
      new_board: this.form.value,
    };
    this.api.completeCompanyProductPhaseBoard(this.board.id as string, body).subscribe(
      data => {
        this.loading = false;
        this.dialogRef.close(data);
      },
      error => {
        this.loading = false;
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCancel() {
    this.dialogRef.close();
  }
}
